<!--
  @author:chen.hao
  @time:2018/11/7
  @disc:供应商管理弹出层信息展示
 -->

<template>
  <el-form label-width="140px">
    <el-row>
      <el-col :span="12">
        <el-form-item label="用户名">{{infoData.username}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册时间">{{infoData.registerTime}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册手机号">{{infoData.mobile}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="法定代表人归属地">{{infoData.repLglPersonLoc}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="企业名称">{{infoData.companyName}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="法定代表人姓名">{{infoData.repLglPersonName }}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="企业类型">
          {{['','企业','事业单位','民办非企业','个体工商户','社会团体','党政及国家机关'][infoData.companyType]}}
        </el-form-item>
      </el-col>
      <!--<el-col :span="12">
        <el-form-item label="法人代表">{{infoData}}</el-form-item>
      </el-col>-->
      <el-col :span="12">
        <el-form-item label="证件类型">{{['','普通营业执照','多证合一营业执照'][infoData.certificateType]}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="法定代表人身份证号">{{infoData.repLglPersonIdentity}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册号">{{infoData.registLicence}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="代理人姓名">{{infoData.legalAgentName}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="组织机构代码">{{infoData.organizationCode}}</el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="代理人身份证号">{{infoData.legalAgentIdentity}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="单位证件照">
          <img-view :src="infoData.companyCertImg" class="img-view"></img-view>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="组织机构代码证">
          <img-view :src="infoData.organisationCodeCertImg" class="img-view"></img-view>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="法人身份证照片">
          <img-view :src="item" alt="" v-for="item in infoData.repLglPersonIDImgs" :key="item" class="img-view"></img-view>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="代理人身份证照片">
          <img-view :src="item" alt="" v-for="item in infoData.legalAgentIDImgs" :key="item" class="img-view"></img-view>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="infoData.contract">
        <el-form-item label="材料合同">
          <a
            v-for="item in JSON.parse(infoData.contract)"
            :href="item"
            :key="item"
            download
            target="_blank">附件下载;</a>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="状态">{{['待认证','未通过','通过'][infoData.status]}}</el-form-item>
      </el-col>
      <template v-if="infoData.status!==0">
        <el-col :span="12">
          <el-form-item label="审核时间">{{infoData.auditTime}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="审核人">{{infoData.auditor}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="审核人部门">{{infoData.auditorDepartment}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">{{infoData.remark}}</el-form-item>
        </el-col>
      </template>
    </el-row>
  </el-form>
</template>

<script>
import ImgView from '../../../components/imgView/index'
export default {
  name: 'info',
  components: { ImgView },
  props: ['infoData']
}
</script>

<style scoped>
.img-view {
  width: 150px;
  height: 150px;
  margin-right: 10px;
  float: left;
}
</style>
